import { render, staticRenderFns } from "./tagEntry.vue?vue&type=template&id=63219560&scoped=true&"
import script from "./tagEntry.vue?vue&type=script&lang=js&"
export * from "./tagEntry.vue?vue&type=script&lang=js&"
import style0 from "./tagEntry.vue?vue&type=style&index=0&id=63219560&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63219560",
  null
  
)

export default component.exports